import { render, staticRenderFns } from "./PayrollOtherPayments.vue?vue&type=template&id=2989e812&scoped=true&"
import script from "./PayrollOtherPayments.vue?vue&type=script&lang=js&"
export * from "./PayrollOtherPayments.vue?vue&type=script&lang=js&"
import style0 from "./PayrollOtherPayments.vue?vue&type=style&index=0&id=2989e812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2989e812",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2989e812')) {
      api.createRecord('2989e812', component.options)
    } else {
      api.reload('2989e812', component.options)
    }
    module.hot.accept("./PayrollOtherPayments.vue?vue&type=template&id=2989e812&scoped=true&", function () {
      api.rerender('2989e812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Payroll/PayrollOtherPayments.vue"
export default component.exports